<div class="overflow-x-auto rounded-box border border-base-content/5 bg-base-100">
  <table class="table table-zebra">
    <thead>
    <tr>
      <th><app-sort-button [label]="'Id'" [column]="'id'" [(order)]="order" (orderChange)="updateList()"></app-sort-button></th>
      <th><app-sort-button [label]="'Nome'" [column]="'name'" [(order)]="order" (orderChange)="updateList()"></app-sort-button></th>
      <th><app-sort-button [label]="'Periodo'" [column]="'period'" [(order)]="order" (orderChange)="updateList()"></app-sort-button></th>
      <th><app-sort-button [label]="'Data'" [column]="'created_at'" [(order)]="order" (orderChange)="updateList()"></app-sort-button></th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      @if (paginatedResponse().data.length > 0) {
        @for (item of paginatedResponse().data; track item.id) {
          <tr class="hover:bg-base-300">
            <th>{{item.id}}</th>
            <td>{{item.name}}</td>
            <td>{{item.period | date: 'MM/YYYY'}}</td>
            <td>{{item.created_at_locale | date: 'dd/MM/YYYY HH:mm:ss'}}</td>
            <td>
              <button class="btn btn-xs btn-info" (click)="onDownload(item)">Scarica</button>
              <button class="ml-2 btn btn-xs btn-error" (click)="openTrashModal(item)">Cancella</button>
            </td>
          </tr>
        }
      } @else {
        <tr>
          <td colspan="5" class="text-center">Nessun risultato</td>
        </tr>
      }
    </tbody>
  </table>
  <app-pagination [paginatedResponse]="paginatedResponse()" (pageChangeEvent)="updateList($event)" (elementsChange)="onElementsChange($event)"></app-pagination>
</div>

<dialog id="trash_modal" class="modal" #trashModal>
  <div class="modal-box">
    <h3 class="text-lg font-bold">Attenzione</h3>
    <p class="py-4">Vuoi cancellare l'export numero {{deleteId()}}?</p>
    <button class="btn btn-error" (click)="destroy(trashModal)">Cancella</button>
    <button class="btn ml-2" (click)="trashModal.close()">Annulla</button>
  </div>
</dialog>
